<div *ngIf="(expired$ | async)" class="bf-session-overlay" role="alertdialog" aria-modal="true" aria-labelledby="bf-session-title">
  <div class="bf-session-overlay__card">
    <i class="fa fa-exclamation-triangle bf-session-overlay__icon" aria-hidden="true"></i>
    <h2 id="bf-session-title" class="bf-session-overlay__title">{{ 'common.session.expired.title' | translate }}</h2>
    <p class="bf-session-overlay__text">{{ 'common.session.expired' | translate }}</p>
    <button type="button" class="bf-session-overlay__button" (click)="reconnect()">
      {{ 'common.session.reconnect' | translate }}
    </button>
  </div>
</div>
